// 서비스 헤더 공통 브랜드 — 메인과 같은 로고·이름·설명.

import { Link } from 'react-router-dom';
import logoIconUrl from '@shared/assets/brand/logo_icon.png';
import styles from './NaviBrand.module.scss';

interface Props {
  to?: string;
  /** 큰 텍스트 라벨. */
  title?: string;
  /** 아래 설명 문구. */
  subtitle?: string;
  /** 다크 배경에 사용할 때만 true. */
  dark?: boolean;
  className?: string;
}

export default function NaviBrand({
  to = '/',
  title = '청년 내비 검사(NAVI)',
  subtitle = '청년 활력·자립·직업진로 역량 검사',
  dark = false,
  className,
}: Props) {
  const cls = [styles.brand, dark ? styles.dark : styles.light, className]
    .filter(Boolean)
    .join(' ');

  return (
    <Link className={cls} to={to} aria-label={title}>
      <img src={logoIconUrl} alt="" className={styles.markIcon} aria-hidden />
      <span className={styles.txt}>
        <b>{title}</b>
        <span>{subtitle}</span>
      </span>
    </Link>
  );
}
